import {Component, EventEmitter, HostBinding, Input, OnDestroy, Output} from '@angular/core';
import {Unit} from '../../../dashboard/monitoring/unit';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {NotificationsService} from 'angular2-notifications';
import {TranslateService} from '@ngx-translate/core';
import {catchError} from 'rxjs/operators';
import {UnitWriteOffFormService} from './unit-write-off-form.service';

@Component({
  selector: 'app-unit-write-off-form',
  templateUrl: './unit-write-off-form.component.html',
})
export class UnitWriteOffFormComponent implements OnDestroy {
  @Output() done: EventEmitter<'cancel' | 'success'> = new EventEmitter<'cancel' | 'success'>();
  @Input() unit: Unit;
  @HostBinding('class.end-user-view-form') unitWriteOffForm = true;
  stateRequest = null;
  formGroup = new FormGroup({
    write_off_comment: new FormControl('', [Validators.required]),
  });

  constructor(
    private notificationsService: NotificationsService,
    private translates: TranslateService,
    private unitWriteOffFormService: UnitWriteOffFormService,
  ) {
  }

  closeFormEvent(event: 'cancel' | 'success') {
    this.done.emit(event);
  }

  submit() {
    if (this.formGroup.valid) {
      this.stateRequest = this.unitWriteOffFormService.doWriteOff(
        this.unit,
        this.formGroup.value['write_off_comment']
      ).pipe(
        catchError((response) => {
            this.notificationsService.error(this.translates.instant('Error'));
            this.unsubscribe();
            throw response.error;
          }
        ),
      ).subscribe(() => {
          this.notificationsService.success(this.translates.instant('Saved'));
          this.closeFormEvent('success');
          this.unsubscribe();
        }
      );
    } else {
      this.notificationsService.alert(this.translates.instant('Form validation error'));
    }
  }

  btnIsDisabled() {
    return this.stateRequest || !this.formGroup.valid;
  }

  unsubscribe() {
    this.stateRequest = null;
  }

  ngOnDestroy(): void {
    this.unsubscribe();
    this.formGroup.reset();
  }
}
